import React from 'react'
import { Card, CardGroup, Col, Row } from 'react-bootstrap'

const UniversityCampus = () => {
  return (
    <>
       <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'>University Campus</Card.Title>
                    <Card.Text className='architectural-modeling-text'>
                    We have created digital twin replicas of historic university campus buildings for virtual campus tours by prospective students and their families. Immersive classroom, laboratory, social and sporting environments can also provide remote students with an “ on campus” experience. 
                    <br />
                    <br />We can work with all virtual world platforms, from Engage VR to Mozilla Hubs, Microsoft’s Altspace VR to Meta’s Horizon Worlds, VRChat, Roblox and Fortnite, whether creating digital twins of your campus, offices, factory or fantas y world.
                    </Card.Text>

                    <Row className='py-md-5 my-md-3'>
                        <Col md={{span:8, offset:2}}>
                            <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/university.jpg"} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{span:12, offset:0}} md={{span:6, offset:0}}>
                            <CardGroup className='amazon-books-cardgroup'>
                                <Row>
                                    <Col md={{span:12, offset:0}}>
                                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                            <Card.Img className='university-images img-fluid' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/uni_001.jpg"} />
                                            <Card.Body>
                                            <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={{span:12, offset:0}}>
                                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                            <Card.Img className='university-images img-fluid' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/uni_001_01.jpg"} />
                                            <Card.Body>
                                            <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardGroup>
                        </Col>
                        <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className="py-md-0 py-5">
                            <CardGroup className='amazon-books-cardgroup'>
                                <Row>
                                    <Col md={{span:12, offset:0}}>
                                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                            <Card.Img className='university-images img-fluid' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/uni_002.jpg"} />
                                            <Card.Body>
                                            <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={{span:12, offset:0}}>
                                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                            <Card.Img className='university-images img-fluid' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/uni_002_01.jpg"} />
                                            <Card.Body>
                                            <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardGroup>
                        </Col>
                    </Row>

                    {/* <CardGroup className='amazon-books-cardgroup'>
                        <Row>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/uni_001.png"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/uni_001_01.png"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>

                    <CardGroup className='amazon-books-cardgroup mt-5'>
                        <Row>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/uni_002.png"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/digital-twin/university/images/uni_002_01.png"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup> */}
                </Card.Body>
            </Card>
        </Card>
      
    </>
  )
}

export default UniversityCampus
